import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Box, Text, useStyleConfig} from '@chakra-ui/react'
import {Navigation, Pagination, Keyboard /*, Mousewheel*/} from 'swiper/modules'
import {Swiper, SwiperSlide} from 'swiper/react'
import PromoSlideVideoCard from './partials/promo-slide-video-card'
import {ChevronRight, ChevronLeft} from '../../icons/arrows'
import {remCalc} from '../../../theme/_utils'
import {HideOnDesktop, HideOnMobile} from '@salesforce/retail-react-app/app/components/responsive'

export const PromoSliderVideo = ({sliderGroup}) => {
    const swiperStyles = useStyleConfig('Swiper')
    const styles = useStyleConfig('PromoSlider')

    const slidesToView = {
        base: 1.2,
        sm: 1.3,
        md: 1.6,
        lg: 1.8,
        xl: 2,
        xxl: 2.5,
    }

    if (!sliderGroup || sliderGroup?.length === 0) return null

    return (
        <Box
            __css={swiperStyles}
            py={{base: remCalc(16), md: remCalc(40)}}
            data-testid="promo-slider-video-container"
        >
            <Swiper
                modules={[Navigation, Pagination, Keyboard]}
                navigation={{
                    prevEl: `.swiper-button-prev`,
                    nextEl: `.swiper-button-next`,
                }}
                pagination={{
                    clickable: true,
                }}
                keyboard={{
                    enabled: true,
                }}
                // mousewheel={true}
                loop={true}
                centeredSlides={true}
                slidesPerView="auto" // Allow slides to respect their own width
                spaceBetween={16} // Adjust spacing between slides
                breakpoints={{
                    0: {
                        spaceBetween: 8, // Smaller spacing for small screens
                        slidesPerView: 'auto',
                    },
                    768: {
                        spaceBetween: 16, // Larger spacing for medium screens
                        slidesPerView: 'auto',
                    },
                    1024: {
                        slidesPerView: slidesToView.lg,
                        spaceBetween: 75,
                    },
                    1200: {
                        slidesPerView: slidesToView.xl,
                        spaceBetween: 100,
                    },
                    1400: {
                        slidesPerView: slidesToView.xxl,
                        spaceBetween: 143,
                    },
                }}
                className="promo-slider-swiper"
            >
                {sliderGroup.map((slider, index) => (
                    <SwiperSlide key={index}>
                        {({isActive}) => (
                            <>
                                <PromoSlideVideoCard
                                    label={slider?.text_block?.label}
                                    title={slider?.text_block?.title}
                                    source={slider?.video_link}
                                    thumbnail={slider?.thumbnail}
                                    isActive={isActive}
                                />
                                <HideOnDesktop>
                                    <Flex
                                        {...styles.content}
                                        data-testid="promo-slide-video-mobile-content"
                                    >
                                        <Text {...styles.label}>{slider?.text_block?.label}</Text>
                                        <Text {...styles.title}>{slider?.text_block?.title}</Text>
                                    </Flex>
                                </HideOnDesktop>
                            </>
                        )}
                    </SwiperSlide>
                ))}

                <HideOnMobile>
                    {/* note chevronIcon is used all swipers thats why top is being overwritten*/}
                    <ChevronLeft
                        className="swiper-button-prev"
                        aria-label="swiper button prev icon"
                        tabIndex={0}
                        sx={{...styles.chevronIcon, top: {md: 'calc(50% - 60px)', lg: '50%'}}}
                        left={{base: '4%', md: '18%', lg: '22%', xl: '26%'}}
                    />
                    <ChevronRight
                        className="swiper-button-next"
                        aria-label="swiper button next icon"
                        tabIndex={0}
                        sx={{...styles.chevronIcon, top: {md: 'calc(50% - 60px)', lg: '50%'}}}
                        right={{base: '4%', md: '18%', lg: '22%', xl: '26%'}}
                    />
                </HideOnMobile>

                <Box className="promo-slider-pagination" />
            </Swiper>
        </Box>
    )
}

PromoSliderVideo.propTypes = {
    sliderGroup: PropTypes.arrayOf(
        PropTypes.shape({
            text_block: PropTypes.shape({
                label: PropTypes.string,
                title: PropTypes.string,
            }),
            video_link: PropTypes.shape({
                href: PropTypes.string,
                title: PropTypes.string,
            }),
        }),
    ),
}
